<template>
  <div id="app">
    <router-view />
    <modal-container />
  </div>
</template>

<script>
import ModalContainer from "./components/ModalContainer";

export default {
  components: { ModalContainer },
  computed:   {
    userType() {
      return this.$store.getters['appUser/type'];
    },
  },
  beforeCreate() {
    this.$store.commit('appUser/UPDATE_TOKEN');
  },
  methods:    {
    handleWindowResize( event ) {
      this.$store.dispatch('updateWindowWidth', event.currentTarget.innerWidth);
    },
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize);
    });
    this.$store.dispatch('updateWindowWidth', window.innerWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  watch:      {
    userType() {
      this.$forceUpdate();
    },
    $route() {
      this.$vs.loading.close();
    },
  },
};
</script>
